var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"align-self-center",attrs:{"src":require("../assets/404-not-found.png"),"contain":"","max-width":"300px"}})}
var staticRenderFns = []

export { render, staticRenderFns }